module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-moon-fill-35ceed1d.svg";